enum RedMatCalculationTypes {
  Docking = 'Docking',
  MolecularDynamics = 'MolecularDynamics',
}

export default RedMatCalculationTypes;
